module.exports = __webpack_public_path__ + "images/vipbg2.png";